import PageHeading, { useAvatarTitle } from './v1';

export { PageHeading, useAvatarTitle };

export default PageHeading;
